import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseConfigService } from '@fuse/services/config';
import { AppConfig, Scheme, Theme, Themes } from 'app/core/config/app.config';
import { Layout } from '../layout/layout.types';

@Component({
    selector     : 'settings',
    templateUrl  : './settings.component.html',
    styles       : [
        `
            settings {
                position: static;
                display: block;
                flex: none;
                width: auto;
            }

            @media (screen and min-width: 1280px) {

                empty-layout + settings .settings-cog {
                    right: 0 !important;
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None
})
export class SettingsComponent implements OnInit, OnDestroy
{
    config: AppConfig;
    layout: Layout;
    scheme: 'dark' | 'light';
    theme: string;
    themes: Themes;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _fuseConfigService: FuseConfigService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit(): Promise<void>
    {//Asincrono, para que no pise el localStorage antes de tiempo y cargue mal el layout
        /*
            Al recargar la pagina, se toma el valor de la configuracion del ls (si existe)
            y se pisa despues de ejecutar la funcion.
            Lo hago asi ya que no puedo envolver al pipe takeUntil con una condicion, ya que no 
            se queda "escuchando". A su vez, necesito que se ejecute al menos una ves el takeUntil, para que quede "escuchando"
         */
        let aux:any='';
        if(!!localStorage.getItem('config')){
            aux = JSON.parse(localStorage.getItem('config'))
        }
        await this.subscribeConfig(aux);//La ejecuto una vez para que quede escuchando los cambios.
        
        //Aca es donde se mantiene la configuracion al recargar.
        localStorage.setItem('config',JSON.stringify(aux))
        this.config = aux;
        this._fuseConfigService.config = this.config
    }
    /*
        Dentro de la funcion, por el takeUntil, se ejecuta siempre que hay un cambio en la config
        y asi obtenemos los cambios en el layout y se guarda en el ls.
    */
    subscribeConfig(a?: any){
        // Subscribe to config changes
        this._fuseConfigService.config$
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((config: AppConfig) => {
                    if(a){
                        /* 
                            Con esta condicion, logro que al recargar, se mantenga el scheme para los overlays.
                            Antes tenia que navegar una vez para que se acomode
                            De igual manera sigue fallando el estilo de los overlay al cambiar el scheme. En ese caso
                            aun hay que navegar para que se corrija
                        */
                        config = a;
                        a = ''
                    }
                    // Store the config
                    this.config = config;
                    localStorage.setItem('config', JSON.stringify(config))
                    //Almaceno la configuracion del usuario en el localStorage
                });

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the layout on the config
     *
     * @param layout
     */
    setLayout(layout: string): void
    {
        // Clear the 'layout' query param to allow layout changes
        this._router.navigate([], {
            queryParams        : {
                layout: null
            },
            queryParamsHandling: 'merge'
        }).then(() => {

            // Set the config
            this._fuseConfigService.config = {layout};
        });
    }

    /**
     * Set the scheme on the config
     *
     * @param scheme
     */
    setScheme(scheme: Scheme): void
    {
        this._fuseConfigService.config = {scheme};
    }

    /**
     * Set the theme on the config
     *
     * @param theme
     */
    setTheme(theme: Theme): void
    {
        this._fuseConfigService.config = {theme};
    }
}
